<template>
  <div id="dcChargeSetTem">
    <el-row class="content" style="margin-top: -45px;padding: 0;">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="contentTitle" style="display: flow-root;position: absolute;right: 2px;top: 13px;z-index: 99;">
          <el-button v-show="editBtn" type="primary" icon="el-icon-edit " style="vertical-align: top;float: right;margin-left: 10px;" @click="edit" />
          <el-button v-show="closeBtn" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="close" /><!--取消-->
          <el-button v-show="viewBtn=='close'" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="clickSet('close')" /><!--收起配置-->
          <!--配置-->
          <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" :disabled="disabledEdit" @click="clickSet('open')" />
          <!-- <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" @click="clickSet('open')" /> -->
        </p>
        <!-- 配置-查看 -->
        <div v-if="viewTable" class="contentWrap" style="padding:0;margin-top: 10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;position:relative;">
                    <div v-if="item.key=='GAFCharge'||item.key=='proCharge'">
                      <span style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                      <i class="el-icon-question" style="font-size:20px;color: #fff;position: relative;vertical-align: middle;" @mouseover="mouseoverQuestion(item)" @mouseout="mouseoutQuestion(item)" />
                      <!-- 问号弹窗 -->
                      <div class="questionPop">
                        <img src="@/assets/images/kisae/2chargeStage.jpg" alt="">
                        <img src="@/assets/images/kisae/3chargeStage.jpg" alt="">
                      </div>
                    </div>
                    <span v-else style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                  </td>
                  <td style="text-align: left;">
                    <el-select v-if="item.key=='type'" v-model="tableEditObjType" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in typeOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='batteryType'" v-model="tableEditObjBatteryType" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='GAFA'" v-model="tableEditObj.esc_I" :disabled="true" :options="GAFAOptions" clearable placeholder="Select" />

                    <el-radio v-if="item.key=='GAFCharge'" v-model="tableEditObj.GAFCharge" :disabled="true" label="2">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='GAFCharge'" v-model="tableEditObj.GAFCharge" :disabled="true" label="3">3 Stages Mode</el-radio>

                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="1" :disabled="true">COLD</el-radio>
                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="2" :disabled="true">NORMAL</el-radio>
                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="3" :disabled="true">HOT</el-radio>

                    <el-select v-if="item.key=='proABSV'" v-model="tableEditObj.proABSV" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in proABSVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-select v-if="item.key=='proV'" v-model="tableEditObj.proV" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in proVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-cascader v-if="item.key=='proA'" v-model="tableEditObj.proA" :disabled="true" :options="GAFAOptions" clearable placeholder="Select" />

                    <el-radio v-if="item.key=='proCharge'" v-model="tableEditObj.proCharge" :disabled="true" label="2">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='proCharge'" v-model="tableEditObj.proCharge" :disabled="true" label="3">3 Stages Mode</el-radio>

                    <el-select v-if="item.key=='LithiumV'" v-model="tableEditObj.LithiumV" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in LithiumVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='LithiumFloatV'" v-model="tableEditObj.LithiumFloatV" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in LithiumFloatVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-cascader v-if="item.key=='LithiumA'" v-model="tableEditObj.LithiumA" :disabled="true" :options="GAFAOptions" clearable placeholder="Select" />

                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" :disabled="true" label="161">ON</el-radio>
                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" :disabled="true" label="162">OFF</el-radio>

                    <el-radio v-if="item.key=='autoStatus'" v-model="tableEditObj.autoStatus" :disabled="true" label="162">ENABLE</el-radio>
                    <el-radio v-if="item.key=='autoStatus'" v-model="tableEditObj.autoStatus" :disabled="true" label="161">DISABLE</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <!-- <tr>
                  <td colspan="3">
                    <el-button type="primary" style="vertical-align: top;margin-right: 20px;float: right;" @click="tableSubmit('charging')">提交</el-button>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <!-- 配置-编辑 -->
        <div v-if="editTable" class="contentWrap" style="padding:0;margin-top:10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;position:relative;">
                    <div v-if="item.key=='GAFCharge'||item.key=='proCharge'">
                      <span style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                      <i class="el-icon-question" style="font-size:20px;color: #fff;position: relative;vertical-align: middle;" @mouseover="mouseoverQuestion(item)" @mouseout="mouseoutQuestion(item)" />
                      <!-- 问号弹窗 -->
                      <div class="questionPop">
                        <img src="@/assets/images/kisae/2chargeStage.jpg" alt="">
                        <img src="@/assets/images/kisae/3chargeStage.jpg" alt="">
                      </div>
                    </div>
                    <span v-else style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                  </td>
                  <td style="text-align: left;">
                    <el-select v-if="item.key=='type'" v-model="tableEditObjType" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in typeOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='batteryType'" v-model="tableEditObjBatteryType" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='GAFA'" v-model="tableEditObj.esc_I" :options="GAFAOptions" placeholder="Select" />

                    <el-radio v-if="item.key=='GAFCharge'" v-model="tableEditObj.GAFCharge" label="2">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='GAFCharge'" v-model="tableEditObj.GAFCharge" label="3">3 Stages Mode</el-radio>

                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="1">COLD</el-radio>
                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="2">NORMAL</el-radio>
                    <el-radio v-if="item.key=='GAFTem'" v-model="tableEditObj.GAFTem" label="3">HOT</el-radio>

                    <el-select v-if="item.key=='proABSV'" v-model="tableEditObj.proABSV" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in proABSVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-select v-if="item.key=='proV'" v-model="tableEditObj.proV" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in proVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-cascader v-if="item.key=='proA'" v-model="tableEditObj.proA" :options="GAFAOptions" placeholder="Select" />

                    <el-radio v-if="item.key=='proCharge'" v-model="tableEditObj.proCharge" label="2">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='proCharge'" v-model="tableEditObj.proCharge" label="3">3 Stages Mode</el-radio>

                    <el-select v-if="item.key=='LithiumV'" v-model="tableEditObj.LithiumV" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in LithiumVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-select v-if="item.key=='LithiumFloatV'" v-model="tableEditObj.LithiumFloatV" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in LithiumFloatVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>

                    <el-cascader v-if="item.key=='LithiumA'" v-model="tableEditObj.LithiumA" :options="GAFAOptions" placeholder="Select" />

                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" label="161">ON</el-radio>
                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" label="162">OFF</el-radio>

                    <el-radio v-if="item.key=='autoStatus'" v-model="tableEditObj.autoStatus" label="162">ENABLE</el-radio>
                    <el-radio v-if="item.key=='autoStatus'" v-model="tableEditObj.autoStatus" label="161">DISABLE</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <tr style="height: 40px;">
                  <td colspan="3">
                    <el-button type="primary" style="vertical-align: top;margin-right: 2px;float: right;" @click="tableSubmit('charging')">{{ $t('button.Submit') }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setDMTCfg, getDMTCfg } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'Bidirectional',
  components: {
  },
  props: {
    online: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dcOnline: false,
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      modelType: null,
      tableDataAll: [
        { key: 'type', isShow: true, name: 'Model', nameZ: '型号', value: '', remark: '' },
        { key: 'batteryType', isShow: true, name: 'Battery Type', nameZ: '电池类型', value: '', remark: 'Select battery type, relevant information will be shown.Type of battery include: GEL,AGM,FLOODED,LITHIUM,PGM' },
        { key: 'GAFA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'GEL/AGM/Flooded 充电电流/浮充电流 ', value: '', remark: 'Bulk/float stage charging current setting. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'GAFCharge', isShow: true, name: 'Charge Mode', nameZ: 'GEL/AGM/Flooded充电阶段', value: '', remark: 'Charging control. 2 stage= for standard charging, 3 stage=for fast charging.' },
        { key: 'GAFTem', isShow: true, name: 'Temp Mode', nameZ: 'GEL/AGM/Flooded温度补偿', value: '', remark: 'Temperature compensation.COLD: used when ambient temp.<5℃. NORMAL:used when 5<=ambient temp<=30℃ HOT: used when ambient temp>30℃' },
        { key: 'proABSV', isShow: true, name: 'Bulk Voltage', nameZ: 'Program-ABS电压', value: '', remark: 'Absorption stage voltage .e.g.Range 13.8 - 14.8 (0.1V step).' },
        { key: 'proV', isShow: true, name: 'Float Voltage', nameZ: 'Program-Float电压', value: '', remark: 'Float stage voltage.e.g.Range 13.0 - 13.7 (0.1V step).' },
        { key: 'proA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'Program 充电电流/浮充电流', value: '', remark: 'Bulk/float charge current setting. Used to determine the end of charging.(e.g. If set to 5A, end current can be 1A/1.5A/2A)' },
        { key: 'proCharge', isShow: true, name: 'Charge Mode', nameZ: 'Program 充电阶段', value: '', remark: 'Charging control. 2 stage= for standard charging, 3 stage=for fast charging.' },
        { key: 'LithiumV', isShow: true, name: 'Bulk Voltage', nameZ: 'Lithium ABS电压', value: '', remark: 'Bulk stage absorption voltage for Li battery.e.g.Range 13.9 - 14.6 (0.1V step).' },
        // { key: 'LithiumFloatV', isShow: true, name: 'Lithium & Float Voltage', nameZ: '锂电浮充电压', value: '', remark: 'Disable/enable equalization function (for flooded battery only). If enabled, can extend the life of battery.' },
        { key: 'LithiumA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'Lithium 充电电流/浮充电流 ', value: '', remark: ' Bulk/float stage charging current setting. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'eqStatus', isShow: true, name: 'EQ Status', nameZ: ' 电池修复功能', value: '', remark: 'Disable/enable equalization function (for flooded battery only). If enabled, can extend the life of battery.' },
        { key: 'autoStatus', isShow: true, name: 'Fan Quiet Mode', nameZ: '风扇静音模式', value: '', remark: 'If disabled the cooling fan will run in full speed. Disable if ambient temperature is high.' }
      ],
      tableEditObj: {
        esc_I: [],
        proA: [],
        LithiumA: [],
        GAFCharge: '',
        GAFTem: '',
        proABSV: '',
        proV: '',
        proCharge: '',
        LithiumV: '',
        eqStatus: '',
        autoStatus: ''
      },
      tableEditObjBatteryType: null,
      tableEditObjType: null,
      typeOptions: [
        { label: 'DMT2430', value: '1' },
        { label: 'DMT1230', value: '2' },
        { label: 'DMT4810', value: '3' },
        { label: 'DMT1250', value: '4' }
      ],
      batteryTypeOptions: [
        { label: 'GEL', value: '1' },
        { label: 'AGM', value: '2' },
        { label: 'Flooded', value: '3' },
        { label: 'Lithium', value: '4' },
        { label: 'Program', value: '5' }
      ],
      GAFAOptions: [],
      proABSVOptions: [],
      proVOptions: [],
      LithiumVOptions: [],
      LithiumFloatVOptions: [],
      mGetCANCfgData: {},
      disabledEdit: true,
      chargeStageIndex: null
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    },
    online: {
      handler(newValue, oldValue) {
        this.dcOnline = newValue
        if (newValue) { this.disabledEdit = false } else { this.disabledEdit = true }
      },
      deep: true
    },
    tableEditObjType: {// 型号
      handler(newValue, oldValue) {
        console.log(newValue)
        if (newValue.indexOf('10') > -1) {
          this.GAFAOptions = [
            {
              value: '2',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            }
          ]
        } else if (newValue.indexOf('30') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 1.5A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 6A' }
              ]
            }
          ]
        } else if (newValue.indexOf('50') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 15A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '5',
              label: 'Bulk 25A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 5A' }
              ]
            },
            {
              value: '6',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 6A' }
              ]
            },
            {
              value: '7',
              label: 'Bulk 35A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 5A' },
                { value: '3', label: 'Float 7A' }
              ]
            },
            {
              value: '8',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '9',
              label: 'Bulk 45A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 9A' }
              ]
            },
            {
              value: '10',
              label: 'Bulk 50A',
              children: [
                { value: '1', label: 'Float 5A' },
                { value: '2', label: 'Float 7A' },
                { value: '3', label: 'Float 10A' }
              ]
            }
          ]
        }
        if (newValue.indexOf('12') > -1) {
          this.proABSVOptions = [
            { label: '13.8 V', value: '1' },
            { label: '13.9 V', value: '2' },
            { label: '14.0 V', value: '3' },
            { label: '14.1 V', value: '4' },
            { label: '14.2 V', value: '5' },
            { label: '14.3 V', value: '6' },
            { label: '14.4 V', value: '7' },
            { label: '14.5 V', value: '8' },
            { label: '14.6 V', value: '9' },
            { label: '14.7 V', value: '10' },
            { label: '14.8 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '13.0 V', value: '1' },
            { label: '13.1 V', value: '2' },
            { label: '13.2 V', value: '3' },
            { label: '13.3 V', value: '4' },
            { label: '13.4 V', value: '5' },
            { label: '13.5 V', value: '6' },
            { label: '13.6 V', value: '7' },
            { label: '13.7 V', value: '8' },
            { label: '13.8 V', value: '9' }
          ]
          this.LithiumVOptions = [
            { label: '13.9 V', value: '1' },
            { label: '14.0 V', value: '2' },
            { label: '14.1 V', value: '3' },
            { label: '14.2 V', value: '4' },
            { label: '14.3 V', value: '5' },
            { label: '14.4 V', value: '6' },
            { label: '14.5 V', value: '7' },
            { label: '14.6 V', value: '8' }
          ]
          this.LithiumFloatVOptions = [
            {	label: '13.5	V',	value: '1'	},
            {	label: '13.6	V',	value: '2'	},
            {	label: '13.7	V',	value: '3'	},
            {	label: '13.8	V',	value: '4'	},
            {	label: '13.9	V',	value: '5'	},
            {	label: '14.0	V',	value: '6'	},
            {	label: '14.1	V',	value: '7'	},
            {	label: '14.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('24') > -1) {
          this.proABSVOptions = [
            { label: '27.6 V', value: '1' },
            { label: '27.8 V', value: '2' },
            { label: '28.0 V', value: '3' },
            { label: '28.2 V', value: '4' },
            { label: '28.4 V', value: '5' },
            { label: '28.6 V', value: '6' },
            { label: '28.8 V', value: '7' },
            { label: '29.0 V', value: '8' },
            { label: '29.2 V', value: '9' },
            { label: '29.4 V', value: '10' },
            { label: '29.6 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '26.0 V', value: '1' },
            { label: '26.2 V', value: '2' },
            { label: '26.4 V', value: '3' },
            { label: '26.6 V', value: '4' },
            { label: '26.8 V', value: '5' },
            { label: '27.0 V', value: '6' },
            { label: '27.2 V', value: '7' },
            { label: '27.4 V', value: '8' },
            { label: '27.6 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '27.8	V',	value: '1'	},
            {	label: '28.0	V',	value: '2'	},
            {	label: '28.2	V',	value: '3'	},
            {	label: '28.4	V',	value: '4'	},
            {	label: '28.6	V',	value: '5'	},
            {	label: '28.8	V',	value: '6'	},
            {	label: '29.0	V',	value: '7'	},
            {	label: '29.2	V',	value: '8'	}
          ]
          this.LithiumFloatVOptions = [
            {	label: '27.0	V',	value: '2'	},
            {	label: '27.2	V',	value: '3'	},
            {	label: '27.4	V',	value: '4'	},
            {	label: '27.6	V',	value: '5'	},
            {	label: '27.8	V',	value: '6'	},
            {	label: '28.0	V',	value: '7'	},
            {	label: '28.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('48') > -1) {
          this.proABSVOptions = [
            { label: '55.2 V', value: '1' },
            { label: '55.6 V', value: '2' },
            { label: '56.0 V', value: '3' },
            { label: '56.4 V', value: '4' },
            { label: '56.8 V', value: '5' },
            { label: '57.2 V', value: '6' },
            { label: '57.6 V', value: '7' },
            { label: '58.0 V', value: '8' },
            { label: '58.4 V', value: '9' },
            { label: '58.8 V', value: '10' },
            { label: '59.2 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '52.0 V', value: '1' },
            { label: '52.4 V', value: '2' },
            { label: '52.8 V', value: '3' },
            { label: '53.2 V', value: '4' },
            { label: '53.6 V', value: '5' },
            { label: '54.0 V', value: '6' },
            { label: '54.4 V', value: '7' },
            { label: '54.8 V', value: '8' },
            { label: '55.2 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '55.6	V',	value: '1'	},
            {	label: '56.0	V',	value: '2'	},
            {	label: '56.4	V',	value: '3'	},
            {	label: '56.8	V',	value: '4'	},
            {	label: '57.2	V',	value: '5'	},
            {	label: '57.6	V',	value: '6'	},
            {	label: '58.0	V',	value: '7'	},
            {	label: '58.4	V',	value: '8'	}

          ]
          this.LithiumFloatVOptions = [
            {	label: '54.0	V',	value: '1'	},
            {	label: '54.4	V',	value: '2'	},
            {	label: '54.8	V',	value: '3'	},
            {	label: '55.2	V',	value: '4'	},
            {	label: '55.6	V',	value: '5'	},
            {	label: '56.0	V',	value: '6'	},
            {	label: '56.4	V',	value: '7'	},
            {	label: '56.8	V',	value: '8'	}
          ]
        }
      },
      deep: true
    },
    tableEditObjBatteryType: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 2) { // GEL/AGM
            if (v.key == 'GAFA' || v.key == 'GAFCharge' || v.key == 'GAFTem') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 3) { // Flooded
            if (v.key == 'GAFCharge' || v.key == 'GAFTem' || v.key == 'eqStatus') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 4) { // Lithium
            if (v.key == 'LithiumV' || v.key == 'LithiumA') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 5) { // Program
            if (v.key == 'proABSV' || v.key == 'proV' || v.key == 'proA' || v.key == 'proCharge') { v.isShow = true } else { v.isShow = false }
          }
          if (v.key == 'type' || v.key == 'batteryType' || v.key == 'autoStatus') { v.isShow = true }// 公共
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    }
  },
  mounted() {
    // getDMTCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
  },
  created() {
  },
  destroyed: function() {
  },
  methods: {
    mouseoverQuestion(item) {
      if (!this.tableEditObjBatteryType) {
        if (item.key == 'GAFCharge') { this.chargeStageIndex = 0 } else { this.chargeStageIndex = 1 }
      } else {
        this.chargeStageIndex = 0
      }
      document.querySelectorAll('.questionPop')[this.chargeStageIndex].style.display = 'block'
    },
    mouseoutQuestion(item) {
      document.querySelectorAll('.questionPop')[this.chargeStageIndex].style.display = 'none'
    },
    resetOnOff(value, name) {
      if (!value) {
        this.tableDataAll.forEach(v => {
          if (name == 'CH1' && (v.sort == 'Ch1' || v.key == 'batteryTypeCh1'))v.isShow = false
          if (name == 'CH2' && (v.sort == 'Ch2' || v.key == 'batteryTypeCh2'))v.isShow = false
          if (name == 'CH3' && (v.sort == 'Ch3' || v.key == 'batteryTypeCh3'))v.isShow = false
        })
      } else { // 打开
        this.tableDataAll.forEach(v => {
          if (name == 'CH1' && (v.sort == 'Ch1' || v.key == 'batteryTypeCh1'))v.isShow = true
          if (name == 'CH2' && (v.sort == 'Ch2' || v.key == 'batteryTypeCh2'))v.isShow = true
          if (name == 'CH3' && (v.sort == 'Ch3' || v.key == 'batteryTypeCh3'))v.isShow = true
        })
      }
    },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        getDMTCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    change(e) {
      this.$forceUpdate()
    },
    tableSubmit() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        'bat_type': this.tableEditObjBatteryType,
        // 'chargeStage': this.tableEditObj.GAFCharge,
        // 'tempCompensation': this.tableEditObj.GAFTem,
        // 'programAbs_V': this.tableEditObj.proABSV,
        // 'programFloat_V': this.tableEditObj.proV,
        // 'programChargeStage': this.tableEditObj.proCharge,
        // 'lithium_V': this.tableEditObj.LithiumV,
        // 'LithiumFloat_V': this.tableEditObj.LithiumFloatV,
        'EQStatus': this.tableEditObj.eqStatus,
        'autoStatus': this.tableEditObj.autoStatus,
        'model': this.tableEditObjType
        // 'charge_I': this.tableEditObj.esc_I[0],
        // 'esc_I': this.tableEditObj.esc_I[1],
        // 'programCharge_I': this.tableEditObj.proA[0],
        // 'programEsc_I': this.tableEditObj.proA[1],
        // 'lithiumCharge_I': this.tableEditObj.LithiumA[0],
        // 'lithiumEsc_I': this.tableEditObj.LithiumA[1],
      }
      if (this.tableEditObj.GAFCharge)param.chargeStage = this.tableEditObj.GAFCharge
      if (this.tableEditObj.GAFTem)param.tempCompensation = this.tableEditObj.GAFTem
      if (this.tableEditObj.proABSV)param.programAbs_V = this.tableEditObj.proABSV
      if (this.tableEditObj.proV)param.programFloat_V = this.tableEditObj.proV
      if (this.tableEditObj.proCharge)param.programChargeStage = this.tableEditObj.proCharge
      if (this.tableEditObj.LithiumV)param.lithium_V = this.tableEditObj.LithiumV
      if (this.tableEditObj.LithiumFloatV)param.LithiumFloat_V = this.tableEditObj.LithiumFloatV
      if (this.tableEditObj.esc_I) {
        param.charge_I = this.tableEditObj.esc_I[0]
        param.esc_I = this.tableEditObj.esc_I[1]
      }
      if (this.tableEditObj.proA) {
        param.programCharge_I = this.tableEditObj.proA[0]
        param.programEsc_I = this.tableEditObj.proA[1]
      }
      if (this.tableEditObj.LithiumA) {
        param.lithiumCharge_I = this.tableEditObj.LithiumA[0]
        param.lithiumEsc_I = this.tableEditObj.LithiumA[1]
      }
      if (this.tableEditObjType) {
        var str = this.tableEditObjType.indexOf('-') > -1 ? this.tableEditObjType.split('-')[0] : this.tableEditObjType
        param.model = str.slice(3)
      }
      this.$confirm('submit change?', '', {// '是否提交修改？'
        confirmButtonText: 'Confirm', // '确定',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        setDMTCfg(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
            this.viewTable = this.editBtn = true
            this.editTable = this.closeBtn = false
            this.viewBtn = 'close'
          }
        })
      }).catch(() => {
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          var mCanData = this.yhubmqtt.mCan
          // console.log('payload***', mCanData.payload)
          if (!mCanData) return
          if (mCanData && mCanData.payload === 'mGetCANCfgData') {
            this.mGetCANCfgData = mCanData.mGetCANCfgData.DMTcfg // 实时详情、警告
            console.log('mGetCANCfgData--', this.mGetCANCfgData)
            if (!this.mGetCANCfgData) {
              return
            }
            if (this.mGetCANCfgData) {
              this.disabledEdit = false
              if (this.mGetCANCfgData.batType) this.tableEditObjBatteryType = this.mGetCANCfgData.batType.toString()
              if (this.mGetCANCfgData.model) this.tableEditObjType = 'DMT' + this.mGetCANCfgData.model.toString(16)
              // if (!this.mGetCANCfgData.model) this.tableEditObjType = 'DMT1230'
              if (this.mGetCANCfgData.chargeStage) this.tableEditObj.GAFCharge = this.mGetCANCfgData.chargeStage.toString()
              if (this.mGetCANCfgData.tempCompensation) this.tableEditObj.GAFTem = this.mGetCANCfgData.tempCompensation.toString()
              if (this.mGetCANCfgData.programAbs_V) this.tableEditObj.proABSV = this.mGetCANCfgData.programAbs_V.toString()
              if (this.mGetCANCfgData.programFloat_V) this.tableEditObj.proV = this.mGetCANCfgData.programFloat_V.toString()
              if (this.mGetCANCfgData.programChargeStage) this.tableEditObj.proCharge = this.mGetCANCfgData.programChargeStage.toString()
              if (this.mGetCANCfgData.lithium_V) this.tableEditObj.LithiumV = this.mGetCANCfgData.lithium_V.toString()
              if (this.mGetCANCfgData.EQStatus) this.tableEditObj.eqStatus = this.mGetCANCfgData.EQStatus.toString()
              if (this.mGetCANCfgData.autoStatus) this.tableEditObj.autoStatus = this.mGetCANCfgData.autoStatus.toString()
              if (this.mGetCANCfgData.charge_I && this.mGetCANCfgData.esc_I) this.tableEditObj.esc_I.push(this.mGetCANCfgData.charge_I.toString(), this.mGetCANCfgData.esc_I.toString())
              if (this.mGetCANCfgData.programCharge_I && this.mGetCANCfgData.programEsc_I) this.tableEditObj.proA.push(this.mGetCANCfgData.programCharge_I.toString(), this.mGetCANCfgData.programEsc_I.toString())
              if (this.mGetCANCfgData.lithiumCharge_I && this.mGetCANCfgData.lithiumEsc_I) this.tableEditObj.LithiumA.push(this.mGetCANCfgData.lithiumCharge_I.toString(), this.mGetCANCfgData.lithiumEsc_I.toString())
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.bag{
  background:#e0e0e085;
}
.card-panel{
  padding-bottom: 20px;
}
#dcChargeSetTem{
  .content{
    // background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .contentWrap {
    background: #27679e;
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    height: 550px;
    width: 100%;
    // background: white;
    padding-top: 20px;
  }
  .middleContentLeft{
    // height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middleContentLeft>div{
    // border:1px solid red;
    // width:100px;
    // height:200px;
  }
  .plugWarp>div:nth-of-type(1){
    display: flex;
    justify-content: center;
  }
  .plugWarp>div:nth-of-type(1) img{
    width: 100px;
    margin-bottom: 10px;
  }
  .plugWarp>div:nth-of-type(2){
    text-align: center;
  }
  .plugWarp>div:nth-of-type(2) img{
    width:30px;
  }
  .plugWarp>div:nth-of-type(2) span{
    line-height: 30px;
    vertical-align: top;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #63bb38;
  }
  .greenDeltaRight{//向右三角形
    width: 0;
    height: 0;
    border-left: 15px solid #63bb38;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .acChargeDiv{
    position: relative;
  }
  .acChargeDiv div:first-child p{
    text-align: center;
  }
  .acChargeDiv>div{
    display: inline-block;
  }
  .acChargeDiv .acChargeInfo{
    vertical-align: top;
  }
  .acChargeInfo>div{
    margin-top:40px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -45px;
  }

  .middleContentRight{
    height: 400px;
    // border:1px solid red;
    position: relative;
    padding-left: 20px;
  }
  .middleContentRight>div{
    // border:1px solid red;
    // height:80px;
    position: absolute;
  }
  .arrowOrLine{
    border-top: 3px solid #63bb38;
    border-right: 3px solid #63bb38;
    position: relative;
  }
  .greenDeltaBottom{
    position: absolute;
    bottom: -5px;
    right: -11px;
  }
  .middleContentRight>div:nth-of-type(1){
    width:calc(100% - 100px);
    top: 47px;
    height: 74px;
  }
  .middleContentRight>div:nth-of-type(2){
    width:calc(100% - 280px);
    top: 105px;
    height: 96px;
  }
  .middleContentRight>div:nth-of-type(3){
    width:calc(100% - 460px);
    top: 162px;
    height: 118px;
  }
  .middleContentRight>div:nth-of-type(4){
    right: 0;
    top: 130px;
  }
  .middleContentRight>div:nth-of-type(5){
    right: 180px;
    top: 210px;
  }
  .middleContentRight>div:nth-of-type(6){
    right: 360px;
    top: 290px;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  .cellTeamBoxImg{
    display: flex;
    justify-content: center;
  }
  .cellTeamBox>img{
    width: 160px;
  }
  .cellTeamBoxInfo{
    text-align: center;
  }
  .cellTeamBoxInfo img{
    width:30px;
  }
  .cellTeamBoxInfo span{
    line-height: 30px;
    vertical-align: top;
  }
  .dottedLine{
   border-top: 3px dotted #e3e3e3;
   border-right: 3px dotted #e3e3e3;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    // color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
  .acChargeWarp{
    padding:0 5%;
  }
  // .acChargeDiv{
  //   position: relative;
  // }
  .acChargeImg{
    width:150px;
    // border:1px solid red;
  }
}
</style>
<style lang="scss">
#dcChargeSetTem{
  .btnSpace{
    height: 40px;
    border: 1px solid #537ba3;
    border-bottom: none;
  }
  .el-radio {
    color: #fff;
  }
  .el-switch__label.is-active {
    color: #1990fc;
  }
  .el-switch__label {
    color: #ffffff;
  }
  .questionPop{
    display: none;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    width: 200%;
  }
  .questionPop img{
    width:100%;
  }
}
</style>
